import { render } from "./board.vue?vue&type=template&id=1109cdfd&scoped=true"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"

import "./board.vue?vue&type=style&index=0&id=1109cdfd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1109cdfd"]])

export default __exports__